export default "__VITE_ASSET__cUn0pJHd__"